const HOME = '/'
const SIGNUP = '/register'
const LOGIN = '/login'
const USER = '/users'
const DEVICES = '/devices'
const MAP = '/map'
const PROFILE = '/profile'
const FORGOT_PASSWORD = '/forgot-password'
const RESET_PASSWORD = '/reset-password'

export default {
    HOME,
    SIGNUP,
    LOGIN,
    DEVICES,
    USER,
    PROFILE,
    MAP,
    FORGOT_PASSWORD,
    RESET_PASSWORD
}